import { jQuery } from './utils/jquery.js';
import { Fancybox } from "@fancyapps/ui";

jQuery(function ($) {
    wishlistInstance = {
        alreadyAddedToWishlistClass: 'is-active',
        wishlistSuccessPopupEl: $('#pop-wishlist-step-2'),
        changeModalProductImage: function (image_url) {
            $('.wishlist-step-two__image_wrap').find('img').attr('src', image_url);
        },
        print_errors: function (errors) {
            $('body').addClass('processing').block({
                message: errors, overlayCSS: {
                    background: '#ff00001f', opacity: 0.6
                }
            });
            setTimeout(function () {
                wishlistInstance.preloader_off();
            }, 2000);
        },
        preloader_on: function () {
            $('body').addClass('processing').block({
                message: "Please wait..", overlayCSS: {
                    background: '#fff', opacity: 0.6
                }
            });
        }, preloader_off: function () {
            $('body').removeClass('processing').unblock();
        }, remove_from_wishlist: function (that, data) {
            data.action = 'woocommerce_wagt_ajax_remove_from_wishlist';
            $.ajax({
                type: 'post', url: window['wagt_ajax_url'], data: data, beforeSend: function (response) {
                    wishlistInstance.preloader_on();
                }, complete: function (response) {
                    wishlistInstance.preloader_off();
                }, success: function (response) {
                    if (response.succ) {
                        wishlistInstance.wishlistSuccessPopupEl.removeClass('added').addClass('removed');
                        wishlistInstance.changeModalProductImage($(that).attr('data-product-image')); // change image
                        Fancybox.show([{src: "#pop-wishlist-step-2", type: "inline"}]);
                        $(that).removeClass(wishlistInstance.alreadyAddedToWishlistClass);
                    } else {
                        // show error
                        alert(response.errors_string);
                        return false;
                    }
                },
            });
            return false;

        }, add_to_wishlist: function (that, data) {
            // do validate product id
            // append action
            data.action = 'woocommerce_wagt_ajax_add_to_wishlist';
            $.ajax({
                type: 'post', url: window['wagt_ajax_url'], data: data, beforeSend: function (response) {
                    wishlistInstance.preloader_on();
                }, complete: function (response) {
                    wishlistInstance.preloader_off();
                }, success: function (response) {
                    if (response.succ) {
                        // TODO manage login popup here
                        wishlistInstance.changeModalProductImage($(that).attr('data-product-image')); // change image
                        wishlistInstance.wishlistSuccessPopupEl.removeClass('removed').addClass('added');
                        Fancybox.show([
                        {
                            src: "#pop-wishlist-step-2",
                            type: "inline"
                        }]);
                        $(that).addClass(wishlistInstance.alreadyAddedToWishlistClass);
                    } else {
                        // show error
                        alert(response.errors_string);
                        return false;
                        // wishlistInstance.print_errors(response.errors_string);
                    }
                },
            });
            return false;
        }
    };

    $(document).on('click', '.js-wagt-add-to-wishlist', function () {
        let product_id = $(this).attr('data-product-id');
        if (typeof product_id === "undefined" || !product_id) {
            return false;
        }

        // check has is-active class if yes then remove this product from wishlist
        if ($(this).hasClass('is-active')) {
            console.log("This has the is-active class");
            wishlistInstance.remove_from_wishlist(this, {
                product_id: product_id
            });
            return;
        }

        wishlistInstance.add_to_wishlist(this, {
            product_id: product_id
        });
    });
});
